import React from 'react';

const OutletContext = React.createContext();

export default OutletContext;
